<script setup lang="ts">
import type { ResolutionTimeDto } from '@/api/reports';

interface Props {
  resolution: ResolutionTimeDto;
}

defineProps<Props>();
</script>

<template>
  <div class="space-y-3" data-testid="report-resolution-times">
    <!-- Critical -->
    <div class="flex items-center gap-3">
      <span class="w-20 shrink-0 text-sm font-medium text-red-700">Critical</span>
      <div class="flex-1 h-1.5 bg-canvas-soft rounded-full overflow-hidden">
        <div class="h-full bg-red-500 rounded-full" style="width: 70%" />
      </div>
      <span class="font-mono tabular-nums text-sm w-20 text-right shrink-0">
        {{ resolution.criticalMedianDisplay }}
      </span>
      <span
        class="text-xs w-16 text-right shrink-0"
        :class="resolution.criticalWithinSla ? 'text-green-700' : 'text-red-600 font-medium'"
      >
        {{ resolution.criticalWithinSla ? 'Within SLA' : 'Over SLA' }}
      </span>
    </div>

    <!-- High -->
    <div class="flex items-center gap-3">
      <span class="w-20 shrink-0 text-sm font-medium text-orange-600">High</span>
      <div class="flex-1 h-1.5 bg-canvas-soft rounded-full overflow-hidden">
        <div class="h-full bg-orange-400 rounded-full" style="width: 70%" />
      </div>
      <span class="font-mono tabular-nums text-sm w-20 text-right shrink-0">
        {{ resolution.highMedianDisplay }}
      </span>
      <span
        class="text-xs w-16 text-right shrink-0"
        :class="resolution.highWithinSla ? 'text-green-700' : 'text-red-600 font-medium'"
      >
        {{ resolution.highWithinSla ? 'Within SLA' : 'Over SLA' }}
      </span>
    </div>

    <!-- Medium -->
    <div class="flex items-center gap-3">
      <span class="w-20 shrink-0 text-sm font-medium text-amber-700">Medium</span>
      <div class="flex-1 h-1.5 bg-canvas-soft rounded-full overflow-hidden">
        <div class="h-full bg-amber-400 rounded-full" style="width: 70%" />
      </div>
      <span class="font-mono tabular-nums text-sm w-20 text-right shrink-0">
        {{ resolution.mediumMedianDisplay }}
      </span>
      <span
        class="text-xs w-16 text-right shrink-0"
        :class="resolution.mediumWithinSla ? 'text-green-700' : 'text-red-600 font-medium'"
      >
        {{ resolution.mediumWithinSla ? 'Within SLA' : 'Over SLA' }}
      </span>
    </div>

    <!-- Low -->
    <div class="flex items-center gap-3">
      <span class="w-20 shrink-0 text-sm font-medium text-navy-600">Low</span>
      <div class="flex-1 h-1.5 bg-canvas-soft rounded-full overflow-hidden">
        <div class="h-full bg-navy-400 rounded-full" style="width: 70%" />
      </div>
      <span class="font-mono tabular-nums text-sm w-20 text-right shrink-0">
        {{ resolution.lowMedianDisplay }}
      </span>
      <span
        class="text-xs w-16 text-right shrink-0"
        :class="resolution.lowWithinSla ? 'text-green-700' : 'text-red-600 font-medium'"
      >
        {{ resolution.lowWithinSla ? 'Within SLA' : 'Over SLA' }}
      </span>
    </div>
  </div>
</template>
